const TerraceComponent = () => import('@/views/WareHouse/terrace/TerraceView')

export default [
    {
        path:'/TerraceIndex',
        name:'TerraceComponent',
        component:TerraceComponent
    }
]